module.exports = __webpack_public_path__ + "img/couples-022.c3c5b316.jpg";